import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { HashRouter as Router } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import { SearchProvider } from "./components/shared/Context/SearchContext";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename="/northeasternelectricpower">
        <SearchProvider>
          <App />
        </SearchProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
